import React from 'react';
import { TestDriveSchedulerAdmin } from '@lucid/test-drive-scheduler';
import '@lucid/test-drive-scheduler/dist/test-drive-scheduler.css';
import { useSchedulerHostProps } from '../../../hooks/useSchedulerHostProps';
import { useUserRole } from '../../../hooks/useUserRole';

const TestDriveScheduler: React.FC = () => {
  const hostProps = useSchedulerHostProps();
  const { isLoading: isRoleLoading } = useUserRole();

  // Roles are empty until the Auth0 claims load; rendering earlier flashes the no-access state for admins.
  if (isRoleLoading) return null;

  return <TestDriveSchedulerAdmin {...hostProps} />;
};

export default TestDriveScheduler;
